import {Controller} from "stimulus"
import {openInspectionsMessage} from "./helpers/open_inspections_message"
import {outstandingTasksMessage} from "./helpers/outstanding_tasks_message"

// Change Status on a permit: before a status that issues the permit is saved
// with tasks still open, or one that completes it with inspections still
// open, ask staff to confirm -- the same warnings the edit form gives when the
// issue or completed date is filled in. The server lists only the labels that
// would set a date not yet set.
export default class extends Controller {
    static targets = ["state"]

    confirm(e) {
        const message = this.warningFor(this.stateTarget.value)
        if (message && !window.confirm(message)) {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    warningFor(state) {
        const openTasks = this.list("openTasks")
        if (this.list("issuingStates").includes(state) && openTasks.length > 0) {
            return outstandingTasksMessage(openTasks)
        }

        const openInspections = this.list("openInspections")
        if (this.list("completingStates").includes(state) && openInspections.length > 0) {
            return openInspectionsMessage(openInspections)
        }

        return null
    }

    list(key) {
        try {
            return JSON.parse(this.data.get(key) || "[]")
        } catch (e) {
            return []
        }
    }
}
